function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// ========================================================================
// Validation
// ========================================================================

import Validation from '../modules/lg/validation';
var FormValidation = /*#__PURE__*/function () {
  function FormValidation() {
    _classCallCheck(this, FormValidation);
    this.formValidator();
  }
  _createClass(FormValidation, [{
    key: "formValidator",
    value: function formValidator() {
      this.validation = new Validation({
        forms: {
          ContactForm: {
            FirstName: 'required',
            LastName: 'required',
            Email: 'email',
            Phone: 'required',
            Type: 'required',
            Region: 'required',
            Message: 'minLength:20|maxLength:3000',
            'g-recaptcha-response': 'required'
          },
          ProductEnquiryForm: {
            FirstName: 'required',
            LastName: 'required',
            Email: 'email',
            Phone: 'required',
            Product: 'required',
            Type: 'required',
            Region: 'required',
            Message: 'minLength:20|maxLength:3000',
            'g-recaptcha-response': 'required'
          }
        },
        messages: {
          ContactForm: {
            FirstName: {
              required: 'Please enter your first name'
            },
            LastName: {
              required: 'Please enter your last name'
            },
            Email: {
              email: 'Please enter a valid email address'
            },
            Phone: {
              required: 'Please enter a phone number'
            },
            Type: {
              required: 'Please let us know how we can help'
            },
            Region: {
              required: 'Please choose your region'
            },
            Message: {
              minLength: 'Your message must be a minimum of 20 characters',
              maxLength: 'Your message must be a maximum of 3000 characters'
            },
            'g-recaptcha-response': {
              required: 'You must check the "I\'m not a robot" box.'
            }
          },
          ProductEnquiryForm: {
            FirstName: {
              required: 'Please enter your first name'
            },
            LastName: {
              required: 'Please enter your last name'
            },
            Email: {
              email: 'Please enter a valid email address'
            },
            Phone: {
              required: 'Please enter a phone number'
            },
            Type: {
              required: 'Please let us know how we can help'
            },
            Product: {
              required: 'Product is required'
            },
            Region: {
              required: 'Please choose your region'
            },
            Message: {
              minLength: 'Your message must be a minimum of 20 characters',
              maxLength: 'Your message must be a maximum of 3000 characters'
            },
            'g-recaptcha-response': {
              required: 'You must check the "I\'m not a robot" box.'
            }
          }
        },
        submitIDs: {
          ContactForm: 'ContactSubmit',
          ProductEnquiryForm: 'ProductEnquirySubmit'
        },
        inlineLabel: false,
        onError: function onError(e) {
          var formErrors = e[Object.keys(e)[0]];
          if ('g-recaptcha-response' in formErrors) {
            var recaptchaErrors = formErrors['g-recaptcha-response'];
            var errorText = recaptchaErrors[Object.keys(recaptchaErrors)[0]];
            FormValidation.setRecaptchaError(false, true, errorText);
          } else {
            FormValidation.setRecaptchaError(false, false);
          }
        }
      });
      this.validation.bindEvents();
    }
  }], [{
    key: "setRecaptchaError",
    value: function setRecaptchaError() {
      var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var on = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var parentElement = parent || document.querySelector('div.g-recaptcha').parentElement;
      var errorContainer = parentElement.querySelector('div.error-container');
      if (on && !errorContainer) {
        parentElement.innerHTML += "<div class=\"error-container error-container--filled\" style=\"display: block;\"><p>".concat(text, "</p></div>");
      }
      if (!on && errorContainer) {
        parentElement.removeChild(errorContainer);
      }
    }
  }]);
  return FormValidation;
}();
export { FormValidation as default };